import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';

export interface menus {
  name: string;
  redirectURL: string;
  isMobMenu: string;
  isNew: boolean;
}
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  appLogo: string;
  navbarOpen = false;
  constructor(private router: Router) {
    this.appLogo = '../../assets/images/akrti copy.png';
  }
  ngOnInit() {
  }
  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }
}

//   @ViewChild('toggleMenuBtn', { static: true }) toggleBTN: ElementRef<HTMLElement>;


//   public innerWidth: any;

//   mobileIconFix: boolean = false;

//   showMobMenu: boolean = false;

//   flag: boolean = true;
//
//   selectedMenu: menus;
//   menusData: menus[] = [
//     {
//       name: 'How To Order From Home',
//       redirectURL: '#how-to-order-from-home',
//       isMobMenu: "common",
//       isNew: true
//     },
//     {
//       name: 'PickUp/Delivery Service Areas',
//       redirectURL: '#service-coverage-areas',
//       isMobMenu: "common",
//       isNew: true
//     },
//     {
//       name: 'Our Safety Measures',
//       redirectURL: '#covid-safety-measures',
//       isMobMenu: "common",
//       isNew: true
//     },
//     {
//       name: 'Services',
//       redirectURL: '#what-we-do',
//       isMobMenu: "mobile",
//       isNew: false
//     },
//     {
//       name: 'Services',
//       redirectURL: '#covid-services-new',
//       isMobMenu: "desktop",
//       isNew: false
//     },

//     {
//       name: 'About',
//       redirectURL: '#about-sec',
//       isMobMenu: "common",
//       isNew: false
//     },
//     {
//       name: 'Gallery',
//       redirectURL: '#gallery-sec',
//       isMobMenu: "common",
//       isNew: false
//     },
//     {
//       name: 'Contact Us',
//       redirectURL: '#contact',
//       isMobMenu: "common",
//       isNew: false
//     }
//   ];


//

//   ngOnInit() {

//     this.gotoSpecificSection(this.router.url)

//   }


//   listClick(event: any, menu: menus) {
//     console.log("menu");
//     console.log(menu);
//     this.selectedMenu = menu;
//     console.log("active class changed");

//     this.innerWidth = window.innerWidth;
//     console.log("browser width = " + this.innerWidth);
//     if (this.innerWidth <= 992 && menu != null) {
//       this.toggleBTN.nativeElement.click();
//     } if (this.innerWidth >= 992) {
//     }
//   }


//   mobMenuClick() {
//     // hiding mob menu and changing icon
//     this.showMobMenu = false;
//   }



//   gotoSpecificSection(url: string) {
//     console.log('url *** ' + url);
//     let browserURL = url;
//     let redirectLoc = browserURL.replace('/home', '');
//     console.log('redirectLoc === ' + redirectLoc);


//     if (redirectLoc !== null && redirectLoc !== '') {
//       for (let i = 0; i < this.menusData.length; i++) {
//         if (redirectLoc === this.menusData[i].redirectURL) {
//           document.getElementById(this.menusData[i].name).click();
//           console.log('clicked');
//           this.mobileIconFix = true;
//           return false;
//         }
//       }
//     } else {
//       this.mobileIconFix = false;
//     }



//   }


//   toggleMobMenu() {
//     console.log('toggle menu running');
//     this.showMobMenu = !this.showMobMenu;
//   }

//   onSubmit() {

//   }
// }
